import { render, staticRenderFns } from "./BulkOrderLinkCreator.vue?vue&type=template&id=2a641232&scoped=true"
import script from "./BulkOrderLinkCreator.vue?vue&type=script&lang=js"
export * from "./BulkOrderLinkCreator.vue?vue&type=script&lang=js"
import style0 from "./BulkOrderLinkCreator.vue?vue&type=style&index=0&id=2a641232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a641232",
  null
  
)

export default component.exports